import React from 'react';

interface IMatryoshka {
  wrappers?: ReadonlyArray<React.ComponentType>;
}

export const Matryoshka: React.FC<IMatryoshka> = ({ wrappers = [], children }) => {
  const components = wrappers.slice();

  let element = <>{children}</>;

  while (components.length) {
    element = React.createElement(components.pop()!, {}, element);
  }

  return element;
};
